module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('strong', [_vm._v("Sephardic and Mizrahi Jewry")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('em', [_vm._v("From the Golden Age of Spain to Modern Times")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDITED BY")]), _c('br'), _c('em', [_vm._v("Zion Zohar")])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24473954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 63
// module chunks = 0